import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[autofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  // we need to allow string as the value for directive without value is considered to be string empty
  // equivalent with [directive]=""
  @Input() autofocus: BooleanInput;
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.autofocus != null && !coerceBooleanProperty(this.autofocus)) {
      return;
    }

    // Otherwise Angular throws error: Expression has changed after it was checked.
    window.setTimeout(() => {
      this.el.nativeElement.focus();
    });
  }
}
